import React from 'react';
import './progressBar.scss';

export const ProgressBar = ({ progress, className }) => {
    return (
        <div className={['ok-progress-bar', className].join(' ')}>
            <span style={{ width: `${progress}%` }} />
        </div>
    );
};
